export const reservationListFilterOptions = [
  { label: '電話號碼', value: 'phone' },
  { label: '收件地點', value: 'userAddress' },
  { label: '車牌', value: 'vehiclePlate' },
  { label: '尺寸', value: 'vehicleSize' },
  { label: '訂單類型', value: 'orderType' },
  { label: '預約日期', value: 'date' },
  { label: '預約時間', value: 'time' },
  { label: '服務項目', value: 'service' },
  // newColumn：已存過欄位設定的使用者也會自動勾選一次（見 utils/tableFilter.js）
  { label: '推薦商品', value: 'recommendedServices', newColumn: true },
  { label: '服務人員', value: 'serviceUnit' },
  { label: '服務設備', value: 'resourceItem' },
  { label: '預約來源', value: 'origin' },
  { label: '訂單回覆狀態', value: 'replyStatus', defaultChecked: false },
  { label: '訂單總額', value: 'orderPrice' },
  { label: '應付定金', value: 'depositPrice' },
  { label: '付款方式', value: 'paymentType' },
  { label: '會員備註', value: 'userComment' },
  { label: '店家備註', value: 'adminComment' },
  { label: '取消原因', value: 'cancelReasonCode' },
  { label: '取消備註', value: 'cancelReasonNote' },
  { label: '建立時間', value: 'createdAt' },
  { label: '報到時間', value: 'checkInTime' },
  { label: '報到門市', value: 'checkInBranch' },
  { label: '結帳付款狀態', value: 'checkoutPaymentStatus' },
  { label: '合併訂單狀態', value: 'batchOrderStatus' },
  { label: '實付金額', value: 'checkoutTotalPrice' },
  { label: '結帳付款方式', value: 'checkoutPaymentType' },
  { label: '付款狀態', value: 'depositPaymentStatus' },
  { label: '訂單簽署狀態', value: 'orderSignatureStatus' },
]

export const memberReservationListFilterOptions = [
  { label: '訂單類型', value: 'orderType' },
  { label: '收件地點', value: 'userAddress' },
  { label: '預約日期', value: 'date' },
  // { label: '預約時間', value: 'time' },
  { label: '服務項目', value: 'service' },
  { label: '服務人員', value: 'serviceUnit' },
  { label: '預約來源', value: 'origin' },
  { label: '訂單回覆狀態', value: 'replyStatus', defaultChecked: false },
  { label: '訂單狀態', value: 'orderStatus' },
  { label: '訂單總額', value: 'orderPrice' },
  { label: '應付定金', value: 'depositPrice' },
  { label: '付款方式', value: 'paymentType' },
  { label: '結帳付款狀態', value: 'checkoutPaymentStatus' },
  { label: '實付金額', value: 'checkoutTotalPrice' },
  { label: '結帳付款方式', value: 'checkoutPaymentType' },
  { label: '付款狀態', value: 'depositPaymentStatus' },
  { label: '付款狀態', value: 'paymentStatus' },
  { label: '合併訂單狀態', value: 'batchOrderStatus' },
  // { label: '結帳付款狀態', value: 'checkoutPaymentStatus' },
  // { label: '付款狀態', value: 'depositPaymentStatus' },
]

export const memberManageFilterOptions = [
  { label: '電話號碼', value: 'phone' },
  { label: '生日', value: 'birthday' },
  { label: '等級', value: 'level' },
  { label: '標籤', value: 'tag' },
  { label: '聯絡地址', value: 'address' },
  { label: '登入方式', value: 'loginType' },
  { label: '黑名單', value: 'blackList' },
]
